module.exports = __webpack_public_path__ + "static/media/6.3ef11442.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/6.png
// module id = 1501
// module chunks = 0